import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsChoiceButton as ChoiceButton } from './src/index.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(ChoiceButton);
export const FsChoiceButton = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-choice-button.js.map